import { render } from "./InventoryPage.vue?vue&type=template&id=02012801&scoped=true"
import script from "./InventoryPage.vue?vue&type=script&lang=js"
export * from "./InventoryPage.vue?vue&type=script&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=02012801&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02012801"]])

export default __exports__